import { message } from 'antd';

export function validateImage(
  file: { type: string; size: number },
  hasCrop?: boolean,
) {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error('Adicione apenas arquivos JPG/PNG!');
    throw new Error('Image-error');
  }
  const isLt1M = file.size <= 1048576;
  if (!isLt1M && !hasCrop) {
    message.error('Imagem excede o limite de 1MB!');
    throw new Error('Image-error');
  }
}
